import request from '@/utils/request'

export function loanList(data) {
  return request({
    url: '/tcash/getLoanList',
    method: 'get',
    params: data
  })
}
export function loanDetail(data) {
  return request({
    url: '/tcash/getLoanDetail',
    method: 'get',
    params: data
  })
}

///api/tcash/getRepayList
export function getRepayList(data) {
  return request({
    url: '/tcash/getRepayList',
    method: 'get',
    params: data
  })
}

///api/tcash/getCollateralTopUpList
export function getCollateralTopUpList(data) {
  return request({
    url: '/tcash/getCollateralTopUpList',
    method: 'get',
    params: data
  })
}

//'/api/tcash/getCollateralChangeRecordList
export function getCollateralChangeRecordList(data) {
  return request({
    url: '/tcash/getCollateralChangeRecordList',
    method: 'get',
    params: data
  })
}

//api/tcash/getInterestRecordList
export function getInterestList(data) {
  return request({
    url: '/tcash/getInterestRecordList',
    method: 'get',
    params: data
  })
}

///api/tcash/getLoadStatistic
export function getLoadStatistic(data) {
  return request({
    url: '/tcash/getLoadStatistic',
    method: 'get',
    params: data
  })
}
